import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SymptommatrixService {

    constructor(private http: HttpClient) {
    }

    getChatBotHeatMapData(query) {
        return this.http.get<any>(`/api/chatbot/heatmap` + query);
    }
}
